module.exports = __webpack_public_path__ + "img/AdobeStock_238923438.e8600e4b.jpeg";